module.exports = __webpack_public_path__ + "img/event-view-005.85b034dd.jpg";